import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
import { debounceTime, first } from 'rxjs/operators';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';

@Component({
  selector: 'app-withdrawal-mail',
  templateUrl: './withdrawal-mail.component.html',
  styleUrls: ['./withdrawal-mail.component.scss'],
})
export class WithdrawalMailComponent extends WithdrawalBaseComponent implements OnInit {
  @ViewChild(IonContent) content: IonContent;

    public error = null;
    public labels: DepositMainLabels;
    public accountBalances: BalanceModel;
    public vendorLogoUrl: string = '';
    public withdrawalForm: FormGroup;

    public amount: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    
    public name: string;
    public address1: string;
    public address2: string;
    public city: string;
    public province: string;
    public postalCode: string;
    public buttonDisabled:boolean = false;
    public enterCounts = 0;
    enterPressed: boolean;
  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator:Navigator,
    public events:EventsService,
    public withdrawService:WithdrawalService,
    public balanceService:AccountBalanceService,
    public utils:UtilsService,
    public appLinksService: AppLinksService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService
  ) { 
    super();
    this.successMessageService.clearMessage();
    this.error = null;
    this.labels = new DepositMainModel();
  }
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) { 
      if(event.key === 'Enter'){
          this.enterPressed = true;
          this.enterCounts++;
      }
  }

  ngOnInit() {

    this.buttonDisabled = false;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )

        this.amount = this.withdrawalForm.get('amount');
  }
  
  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('check').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
      this.onGetBalance();

      /*this.name = this.cashierService.customer.firstName + " " + this.cashierService.customer.lastName;
      this.address1 = this.cashierService.customer.address.street;
      this.address2 = this.cashierService.customer.address.street2;
      this.city = this.cashierService.customer.address.city;
      this.province = this.cashierService.customer.address.state;
      this.postalCode = this.cashierService.customer.address.postalCode;*/
  }
  
  onGetBalance() {    

    this.balanceService.getBalance().subscribe(
        (balance: BalanceModel) => {
            if (balance) {
                this.accountBalances = balance;                  
            }
        }
    );
    this.error = null;
  }

  submit() {
  this.buttonDisabled = true;
  // Handling multiple enter clicks on mobile
  this.checkEnterSubmission();
  }

  checkEnterSubmission() {
    if(this.enterPressed === true){
        if(this.enterCounts == 1){
            setTimeout(() => { this.onWithdraw() }, 200);
        }
        this.buttonDisabled = false;  
        this.enterPressed = false;
          
    }else {
        setTimeout(() => { this.onWithdraw() }, 200);
    } 
  }

onWithdraw() {
  this.buttonDisabled = true;
  this.successMessageService.clearMessage();
  this.error = null;
 
  // if(this.withdrawalForm.get('amount').value <= 9999){
  //   console.log(this.withdrawalForm.get('amount').value + 'is less than 10K')
  //   return;
  // }
  this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
  this.withdrawalForm.get("payment_type_code").setValue("CH");
  
  // this.logger.log('onWithdraw WithdrawalMailPage', this.withdrawalForm.value);

 
  this.withdrawService.callWithdraw(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe(
      (response: any) => {
          // this.logger.log("callWithdraw response = ", response);
          if (response && !!response.result ) {
              this.buttonDisabled = false;
              // send the withdrawal event
              let depositEventData: AffiliateTrackerCallbackParams = {
                  customer_id: this.cashierService.customer.customerId,
                  amount:     this.withdrawalForm.get('amount').value
              }
              setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);


              this.amount.setValue('');
              this.amount.markAsPristine();
              this.amount.markAsUntouched();

              this.successMessageService.setMessage('Your withdrawal request has been received.');
              
             

              this.balanceService.updateBalance();

              this.content.scrollToTop();

          }
      },
      (error) => {
          this.buttonDisabled = false;
          // handle all deposit errors in base
          this.error = this.handleError(error);
          // this.logger.log("callWithdraw error = ", error);
          this.content.scrollToTop();
      }
  )
   // Clearing the enterCounts after 3 seconds each time a withdrawal request is made.
   setTimeout(()=> {
      this.enterCounts = 0;
  },3000);

  this.error = null;
}


}
